import { Skeleton } from 'antd';
import { VFC } from 'react';
import styled from 'styled-components';

const StyledSkeletonDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .ant-skeleton-element {
    width: 100%;
    margin: 16px auto;
    display: flex;
  }

  .ant-skeleton-element.center {
    justify-content: center;
  }

  .ant-skeleton-input {
    height: 15px;
  }

  .ant-skeleton-avatar {
    height: 100px;
    width: 100px;
  }

  .ant-skeleton-title {
    display: none;
  }

  .ant-skeleton-paragraph {
    li {
      width: 100% !important;
    }
  }
`;

const { Avatar, Input } = Skeleton;

export const LoadingSkeleton: VFC = () => (
  <StyledSkeletonDiv>
    <Input active />
    <Avatar active className="center" />
    <Input active style={{ width: '220px' }} />
    <Input active style={{ width: '220px' }} />
    <Skeleton active paragraph={{ rows: 10 }} />
  </StyledSkeletonDiv>
);
